module.exports = __webpack_public_path__ + "img/drop-teal-md.916abe04.svg";